import { gql } from '@zenbusiness/application-commons-graphql';

import { UI_INSTRUCTION_FRAGMENT } from './UiInstructionFragment';

export const ATTRIBUTES_FRAGMENT = gql`
  fragment AttributesFragment on AssistantAttributes {
    role
    messageType
    threadUuid
    uiInstructions {
      ...UiInstructionFragment
    }
  }
  ${UI_INSTRUCTION_FRAGMENT}
`;
